// extracted by mini-css-extract-plugin
export default {"paymentDetailsTable":"PaymentDetails_paymentDetailsTable__KPF-A"};